export default "__VITE_ASSET__BSgb6fu5__"